import { DataTableCol } from "../../../components/data-table/types";

export const TransactionInvoicesGridCols: DataTableCol[] = [
    {
        title: 'Date',
        control: 'date',
        sortable: false,
        canShowColumn:true
    },
    {
        title: 'Buyer Name',
        control: 'buyer_name',
        sortable: false,
        canShowColumn:true
    },
    {
        title: 'Mobile Number',
        control: 'contact',
        sortable: false,
        canShowColumn:true
    },
    {
        title: 'Invoice Number',
        control: 'invoice_number',
        sortable: false,
        canShowColumn:true
    },
    {
        title: "Actions",
        control:"action",
        canShowColumn:true,
        isView:true
    }
]